import React from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import './index.less';

export interface MenuItem {
  key: string;
  icon?: React.ReactNode;
  label: React.ReactNode;
}

interface MenuProps {
  items: MenuItem[];
  onClick: (key: string) => void;
  className?: string;
  style?: React.CSSProperties;
}

export const CustomMenu: React.FC<MenuProps> = ({
  items,
  onClick,
  className,
  style
}) => {
  const location = useLocation();
  
  return (
    <div className={classNames('custom-menu', className)} style={style}>
      {items.map((item) => (
        <div
          key={item.key}
          className={classNames('menu-item', {
            'menu-item-active': location.pathname.startsWith(item.key)
          })}
          onClick={() => onClick(item.key)}
        >
          {item.icon && <span className="menu-item-icon">{item.icon}</span>}
          <span className="menu-item-label">{item.label}</span>
          <div 
            className="menu-item-circleContainer" 
            style={{ display: location.pathname.startsWith(item.key) ? 'block' : 'none' }}
          >
            <div className="menu-item-circleContainer-top">
              <div className="menu-item-circleContainer-top-bg"></div>
            </div>
            <div className="menu-item-circleContainer-bottom">
              <div className="menu-item-circleContainer-bottom-bg"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}; 